import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { ButtonGroup, FiltersSharedProps } from '@avantstay/backoffice-core'

interface ArrivalsModeFilterProps extends FiltersSharedProps {
  initialValue?: boolean
  onChange: (value?: boolean) => void
}

const _ArrivalsModeFilter: FC<ArrivalsModeFilterProps> = ({ initialValue, onChange }) => {
  return (
    <ButtonGroup
      currentSelection={initialValue}
      options={[
        {
          id: 'default',
          title: 'Default',
          value: false,
        },
        {
          id: 'arrivals',
          title: 'Arrivals Mode',
          value: true,
        },
      ]}
      onClick={onChange}
      rectangular
    />
  )
}

export const ArrivalsModeFilter = observer(_ArrivalsModeFilter)
